import React, {createContext, useContext, useEffect} from 'react';
import {useClientConfig} from '../hooks/useClientConfig';
import {initializeApiClient} from '../services/api/client';

const ClientConfigContext = createContext(null);

export const ClientConfigProvider = ({children}) => {
    const config = useClientConfig();

    useEffect(() => {
        if (config?.apiBaseUrl) {
            initializeApiClient(config.apiBaseUrl);
        }
    }, [config]);

    if (!config) {
        return null;
    }

    return (
        <ClientConfigContext.Provider value={config}>
            {children}
        </ClientConfigContext.Provider>
    );
};

export const useConfig = () => {
    const context = useContext(ClientConfigContext);
    if (!context) {
        throw new Error('Client config error:');
    }
    return context;
};